import authUser from '~/modules/auth/authUser'
import auth from '~/modules/auth/auth'

export default async function ({ route, app }) {
  const excludedRoutes = [
    'index',
    'auth',
    'open-id',
    'show-id',
    'bulk-signature-id',
    'widget-id',
    'templates-id',
    'open-main'
  ]
  if (route && excludedRoutes.includes(route.name)) {
    return
  }
  if (app.router.currentRoute.query?.token && route.name === 'documents-id') {
    return
  }
  if (auth.isAuthenticated() && !authUser.get()) {
    await authUser.api.load()
  }
}
